import { useQuery } from "@tanstack/react-query";
import { SUPER_ADMIN_COMPANIES_QUERY_KEY, SuperAdminCompany } from "../interfaces";
import { getSuperAdminCompanies } from "../action/getSuperAdminCompanies";

export const useSuperAdminCompaniesQuery = () => {
  return useQuery<SuperAdminCompany[]>({
    queryKey: SUPER_ADMIN_COMPANIES_QUERY_KEY,
    queryFn: getSuperAdminCompanies,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 1,
  });
};
